import { Auth } from '@ax/auth';
import { getProviderPreferenceTemplate } from '@ax/service';
import { useQuery } from '@tanstack/react-query';

export function useGetProviderPreferenceTemplateApi() {
  const query = useQuery({
    queryKey: ['providerPreferenceTemplate'],
    queryFn: () => getProviderPreferenceTemplate(),
    onError: (error: Error) => {
      console.log(error);
    },
    enabled: !!Auth.haveToken(),
    cacheTime: 0,
  });
  return query;
}
